import React, { useEffect, useState } from "react"
import { imagePath } from "constants/constants"
import Select from "react-select"
import { isEmpty } from "lodash"
import { Link } from "react-router-dom"
import MetaTags from "react-meta-tags"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Input,
  CardImg,
  CardSubtitle,
  Col,
  Container,
  Form,
  Label,
  Row,
} from "reactstrap"
import Datetime from "react-datetime"
import { withRouter } from "react-router-dom"
import { formValidation, mapDataForDropDown } from "helpers/helpers"
import Dropzone from "react-dropzone"

//Date Picker
import "react-datepicker/dist/react-datepicker.css"

import "assets/scss/datatables.scss"
import { useSelector, useDispatch } from "react-redux"
// Form Editor
import { Editor } from "react-draft-wysiwyg"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"

import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { apiError, removeError } from "store/actions"
import FieldValidation from "./../../../../components/Common/FieldValidation"
import { updateCampaign } from "store/Campaigns/actions"
import { getAllCampaignsCall } from "./../../../../helpers/repository"
import { sitename } from "./../../../../constants/constants"
const Edit = props => {
  const dispatch = useDispatch()
  const [name, setname] = useState("")
  const [message, setmessage] = useState("")
  const [link, setlink] = useState("")
  const [banner, set_banner] = useState({})
  const [startDate, setstartDate] = useState("")
  const [endDate, setendDate] = useState("")

  useEffect(() => {
    getDefaultState()
    dispatch(apiError(""))
  }, [])

  const urlParams = new URLSearchParams(props.location.search)

  function handleAcceptedFiles(files) {
    removeError("banner")
    files.map(file => {
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file?.size),
      })
      set_banner(file)
    })
  }

  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }
  const handleSubmit = e => {
    e.preventDefault()
    const data = {
      // id: +urlParams.get("id"),
      name: name,
      message: message,
      link: link,
      image: banner,
      startDate: convertToUTC(startDate),
      endDate: convertToUTC(endDate),
    }
    console.log(banner);
    if (banner instanceof File == false) {
      delete data["image"]
    }

    let form_data = new FormData()

    for (let key in data) {
      form_data.append(key, data[key])
    }

    dispatch(updateCampaign(form_data, props.history, +urlParams.get("id")))
  }
  const convertToLocal = utcDateTime => {
    const utcDate = new Date(utcDateTime)

    const year = utcDate.getFullYear()
    const month = String(utcDate.getMonth() + 1).padStart(2, "0")
    const day = String(utcDate.getDate()).padStart(2, "0")
    const hours = String(utcDate.getHours()).padStart(2, "0")
    const minutes = String(utcDate.getMinutes()).padStart(2, "0")
    const seconds = String(utcDate.getSeconds()).padStart(2, "0")

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
  }

  const convertToUTC = localDateTime => {
    const localDate = new Date(localDateTime)
    return localDate.toISOString()
  }

  const formErrors = useSelector(state => state?.CommonState)
  const removeError = key => {
    let e = _.cloneDeep(formErrors)
    delete e[key]
    dispatch(apiError(e))
  }

  const getDefaultState = () => {
    getAllCampaignsCall().then(res => {
      let obj = res.data.data.filter(sp => sp["id"] == urlParams.get("id"))

      obj = obj.length > 0 ? obj[0] : {}
      setname(obj?.name)
      setmessage(obj?.message)
      setlink(obj?.link)
      set_banner({
        name: obj["banner"],
        preview: obj["banner"],
      })
      setstartDate(convertToLocal(obj?.startDate))
      setendDate(convertToLocal(obj?.endDate))
    })
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Bonuses" breadcrumbItem="Edit" />
          <Card>
            <h5 className="card-header bg-transparent border-bottom text-uppercase">
              Edit Campaign
            </h5>

            <CardBody>
              <Form onSubmit={handleSubmit}>
                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Name
                  </Label>
                  <Col sm={5}>
                    <input
                      className="form-control"
                      type="text"
                      onChange={e => {
                        removeError("name")
                        setname(e.target.value)
                      }}
                      value={name}
                    />
                    {formErrors?.name ? (
                      <FieldValidation errorMessage={formErrors?.name} />
                    ) : null}
                  </Col>
                </div>

                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Message
                  </Label>
                  <Col sm={5}>
                    <textarea
                      className="form-control"
                      id="subject"
                      rows="5"
                      //   maxLength="124"
                      name="message"
                      onChange={e => {
                        removeError("message")
                        setmessage(e.target.value)
                      }}
                      value={message}
                    />
                    {formErrors?.message ? (
                      <FieldValidation errorMessage={formErrors?.message} />
                    ) : null}
                  </Col>
                </div>
                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Link
                  </Label>
                  <Col sm={5}>
                    <textarea
                      className="form-control"
                      id="subject"
                      rows="2"
                      //   maxLength="124"
                      name="link"
                      onChange={e => {
                        removeError("link")
                        setlink(e.target.value)
                      }}
                      value={link}
                    />
                    {formErrors?.message ? (
                      <FieldValidation errorMessage={formErrors?.link} />
                    ) : null}
                  </Col>
                </div>
                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Banner
                  </Label>
                  <Col sm={5}>
                    {isEmpty(banner.name) ? (
                      <Dropzone
                        onDrop={acceptedFiles => {
                          handleAcceptedFiles(acceptedFiles)
                        }}
                        multiple={false}
                      >
                        {({ getRootProps, getInputProps }) => (
                          <div className="dropzone">
                            <div
                              className="dz-message needsclick mt-2"
                              {...getRootProps()}
                            >
                              <input {...getInputProps()} />
                              <div className="mb-3">
                                <i className="display-4 text-muted bx bxs-cloud-upload" />
                              </div>
                              <h4>Drop files here or click to upload.</h4>
                              <em style={{ fontSize: "12px", color: "red" }}>
                                (Only *.jpg and *.png images will be accepted)
                              </em>
                              <br></br>
                              <em style={{ fontSize: "10px", color: "red" }}>
                                (Image Dimension should be 1000x500)
                              </em>
                            </div>
                          </div>
                        )}
                      </Dropzone>
                    ) : (
                      <>
                        <div className="dropzone">
                          <>
                            <div className="promotions-banner-title p-1">
                              <CardTitle>Campaign Image</CardTitle>
                              <button
                                type="button"
                                className="btn-close"
                                aria-label="Close"
                                onClick={() => {
                                  set_banner([])
                                }}
                              ></button>
                            </div>
                            <CardImg
                              data-dz-thumbnail=""
                              height="80"
                              alt={banner?.name}
                              src={
                                [undefined].includes(banner.formattedSize)
                                  ? imagePath("campaigns", banner.preview)
                                  : banner.preview
                              }
                              className="img-fluid p-1 dropzone-img"
                              id="bannerid"
                            />
                          </>
                        </div>
                      </>
                    )}

                    {formErrors?.image?.length >= 0 ? (
                      <FieldValidation errorMessage={formErrors?.image[0]} />
                    ) : null}
                  </Col>
                </div>
                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Schedule Date
                  </Label>
                  <Col sm={5}>
                    <input
                      className="form-control"
                      type="datetime-local"
                      onChange={e => {
                        removeError("startDate")
                        setstartDate(e.target.value)
                      }}
                      value={startDate}
                    />
                    {formErrors?.startDate ? (
                      <FieldValidation errorMessage={formErrors?.startDate} />
                    ) : null}
                  </Col>
                </div>
                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    End Date
                  </Label>
                  <Col sm={5}>
                    <input
                      className="form-control"
                      type="datetime-local"
                      onChange={e => {
                        removeError("endDate")
                        setendDate(e.target.value)
                      }}
                      value={endDate}
                    />
                    {formErrors?.endDate ? (
                      <FieldValidation errorMessage={formErrors?.endDate} />
                    ) : null}
                  </Col>
                </div>
                <div className="row">
                  <Col sm={3}></Col>
                  <Col sm={9}>
                    <Row>
                      <Col sm={4} xs={6} md={4} lg={3} xl={2}>
                        <Button type="submit" color="primary" className="w-100">
                          Submit
                        </Button>
                      </Col>
                      <Col sm={4} xs={6} md={4} lg={3} xl={2}>
                        <Button
                          type="button"
                          color="secondary"
                          className="w-100"
                          onClick={() => {
                            props.history.push("/crm/content/campaigns")
                          }}
                        >
                          Cancel
                        </Button>
                      </Col>
                      <Col sm={4} md={4} lg={6} xl={8}></Col>
                    </Row>
                  </Col>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}
export const EditCampaigns = withRouter(Edit)
